<div class="list-wrapper">
    <kgrid #grid
       *ngIf="filterInfo && filterInfo.length > 0"
       [apiName]="apiName"
       [label]="label"
       [name]="apiName"
       [areaName]="areaName"
       pathPreFix="HRM"
       [isMulti]="true"
       [isAdd]="false"
       [isEdit]="false"
       [isDelete]="false"
       defaultSortKey="PersCode"
       defaultSortKeyKind='asc'
       [defaultFilterKey]="filterInfo"
       [actionTregger]="onActionClick"
       [actions]="actions">
</kgrid>   
</div>

